<!--suppress TypeScriptValidateTypes -->
<div class="info-container">
  <div>
    <h2>{{ 'lo-needs.aboutThePatient' | translate }}</h2>
    <div class="scrolling-y tab-content-padding">
      {{ aboutThePatient }}
    </div>
    <h2>{{ 'lo-needs.needsOfThePatient' | translate }}</h2>
    <div class="scrolling-y tab-content-padding">
      {{ needsOfThePatient }}
    </div>
  </div>
</div>
